module.exports = __webpack_public_path__ + "img/content_title1.ba3cce6b.png";